import styled from 'styled-components';
import { FlexColumn, FlexRow } from '@make-software/tg-mini-app-ui';

import { StyledEarnIcon } from '@/shared';

export const CardGrid = styled.div(({ theme }) =>
  theme.withMedia({
    display: 'grid',
    gridTemplateColumns: 'auto 1fr auto',
    alignItems: 'stretch',
    columnGap: '8px',

    marginTop: '12px',
    border: '1px solid #41424E',
    borderRadius: '8px',
    backgroundColor: '#30313B',
    cursor: 'pointer'
  })
);

export const LogoCell = styled(FlexRow)(({ theme }) =>
  theme.withMedia({
    padding: 8,
    alignItems: 'center'
  })
);

export const ContentCell = styled(FlexColumn)(({ theme }) =>
  theme.withMedia({
    padding: '8px 8px 8px 0',
    gap: '6px',
    minWidth: 0
  })
);

export const HeaderRowGrid = styled.div(({ theme }) =>
  theme.withMedia({
    display: 'grid',
    gridTemplateColumns: '1fr auto',
    columnGap: '8px',
    alignItems: 'center',
    width: '100%'
  })
);

export const TitleBlock = styled(FlexRow)(({ theme }) =>
  theme.withMedia({
    gap: '8px',
    minWidth: 0,
    alignItems: 'center'
  })
);

export const RightStats = styled(FlexRow)(({ theme }) =>
  theme.withMedia({
    gap: '5px',
    alignItems: 'center',
    justifySelf: 'end',
    flexShrink: 0
  })
);

export const RightRail = styled(FlexColumn)(({ theme }) =>
  theme.withMedia({
    padding: 4,
    gap: 10,
    alignSelf: 'stretch',
    borderRadius: '0 4px 4px 0',
    backgroundColor: '#3A3B46',
    svg: {
      path: {
        fill: 'none'
      }
    }
  })
);

export const BalanceValue = styled.span`
  color: #a9aaad;
  font-size: 12px;
  font-weight: 500;
  font-family: 'JetBrains Mono', monospace;
  letter-spacing: -0.24px;
  line-height: 140%;
  text-align: center;
`;

export const EarnIconContainer = styled(StyledEarnIcon)`
  flex-shrink: 0;
`;
